// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3Mtpw","unreadBadge":"styles_unreadBadge__3nWT5","modalContent":"styles_modalContent__rCD5m","modal":"styles_modal__15ITm"};